module.exports = __webpack_public_path__ + "static/img/2areaA_12.837e614.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/2areaA_12.png
// module id = 975
// module chunks = 1